import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../../../core/defaultValues";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { resetALL } from "../../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../../core/logManager";

const INIT_STATE = {
  loadingDriverStatusList: false,
  driverStatusList: [],
  totalDriverStatusList: 0,
  dataExport: { total: 0, items: [] },
  error: null
};

const route = "modules/manage/views/main/components/driverStatusTab/redux/slice.";

const manageSearchDriverStatus = createAsyncThunk(
  "manage/driverStatusTab/manageSearchDriverStatus",
  async ({ conditions = [], openSearch, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      let condition = {};
      if (openSearch) {
        condition = {
          fields: ["name"],
          terms: openSearch,
          exact: false
        };
      }

      if (condition?.fields || condition?.range) {
        conditions.push(condition);
      }
      const response = await clientQuery(
        manageSearchDriverStatus.query,
        {
          conditions,
          sort,
          limit,
          offset
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchDriverStatus");
      return rejectWithValue(exc);
    }
  }
);

manageSearchDriverStatus.query = `
    query ($conditions: [DriverStatusSearchInput], $sort: [DriverStatusSortInput], $limit: Int, $offset: Int) {
        data: searchDriverStatus(
            conditions: $conditions 
            sort: $sort 
            limit: $limit 
            offset: $offset
        ) {
            total
            items {
                id
                name
                accumulateTime
                updatedOn
                updatedBy
                createdBy
                createdOn
            }
        }
    }
`;

export { manageSearchDriverStatus };

//Slice
const manageDriverStatusTabRedux = createSlice({
  name: "manage/driverStatusTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageSearchDriverStatus
    builder.addCase(manageSearchDriverStatus.pending, (state) => {
      state.loadingDriverStatusList = true;
    });
    builder.addCase(manageSearchDriverStatus.fulfilled, (state, action) => {
      state.loadingDriverStatusList = false;
      state.driverStatusList = action.payload.items;
      state.totalDriverStatusList = action.payload.total;
    });
    builder.addCase(manageSearchDriverStatus.rejected, (state, action) => {
      state.loadingDriverStatusList = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageDriverStatusTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
